module.exports = "/_next/static/images/icon-no-search-9ca9b7d1cb7b71368c3f92a2b9bce3ec.svg";